/** @jsx jsx */
import React, { useState } from 'react';
import { css, jsx } from '@emotion/core';
import { useTheme } from '@material-ui/core';
import { Thumbnail } from './Thumbnail';
import ImageModal from 'Components/ImageModal';

export const Thumbnails = props => {
  const theme = useTheme();
  const [modalPreviewInformation, setModalPreviewInformation] = useState({});

  function onClickPreviewImage({ imgSrc, fileName, videoURL }) {
    setModalPreviewInformation({
      imgSrc,
      fileName,
      videoURL,
    });
  }

  return (
    <>
      <div
        css={css`
          display: flex;
          justify-content: space-between;
          margin-top: 11px;
          ${theme.breakpoints.up('sm')} {
            flex-direction: column;
            margin-top: 0;
            margin-left: 26px;
          }
        `}
      >
        <Thumbnail
          css={css`
            flex: 1;
          `}
        >
          <img
            src="https://firebasestorage.googleapis.com/v0/b/receiptcoin-receiptchain-de560.appspot.com/o/items%2F000000000000%2Fvideo.png?alt=media&token=303341dc-96b8-49f6-9750-ab9324813348"
            alt="Token"
            onClick={() => {
              onClickPreviewImage({
                videoURL:
                  'https://firebasestorage.googleapis.com/v0/b/receiptcoin-receiptchain-de560.appspot.com/o/items%2F000000000000%2Fandy-worhol-debbie-harry-nft-video-ownerfy.mp4?alt=media&token=52819901-9f55-4b73-a459-5e14c2fdce0f',
                fileName: 'Recording from the creation of this file',
              });
            }}
          />
        </Thumbnail>

        <Thumbnail
          css={css`
            flex: 1;
            margin-left: 14px;
            ${theme.breakpoints.up('sm')} {
              margin-left: 0;
              margin-top: 26px;
            }
          `}
        >
          <img
            src="https://firebasestorage.googleapis.com/v0/b/receiptcoin-receiptchain-de560.appspot.com/o/items%2F000000000000%2Ffloppy.png?alt=media&token=1eb63460-39fc-4d02-b013-97a8b939fa65"
            alt="Andy Warhol Signed Disk"
            onClick={() => {
              onClickPreviewImage({
                imgSrc:
                  'https://firebasestorage.googleapis.com/v0/b/receiptcoin-receiptchain-de560.appspot.com/o/items%2F000000000000%2FSigned_diskette.jpg?alt=media&token=0e8390e2-3a8e-4e9e-8bf6-78eda2dd7e71',
                fileName: 'Image of Original Disk',
              });
            }}
          />
        </Thumbnail>

        <Thumbnail
          css={css`
            flex: 1;
            margin-left: 14px;
            ${theme.breakpoints.up('sm')} {
              margin-left: 0;
              margin-top: 26px;
            }
          `}
        >
          <a
            href="https://firebasestorage.googleapis.com/v0/b/receiptcoin-receiptchain-de560.appspot.com/o/items%2F000000000000%2FAmiga%20World%20magazine%20relevent%20pages.pdf?alt=media&token=85480757-3c3a-4f90-afec-c4c9757db1e4"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src="https://firebasestorage.googleapis.com/v0/b/receiptcoin-receiptchain-de560.appspot.com/o/items%2F000000000000%2Fmagazine.png?alt=media&token=446be1fb-77b2-4c82-a1d0-01ac06a2918b"
              alt="Token"
            />
          </a>
        </Thumbnail>
      </div>
      <ImageModal
        modalImageInformation={modalPreviewInformation}
        onClickCloseModal={() => setModalPreviewInformation({})}
        maxWidth="md"
      />
    </>
  );
};
